import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'selector', 'submit']

  initialize = () => {
    super.initialize()

    const selector = this.hasSelectorTarget ? this.selectorTarget : this.element
    this.checkboxes = [...selector.querySelectorAll('input[type=checkbox]')]
    this.checkboxes.forEach(checkbox => checkbox.addEventListener('change', () => this.updateState()))

    this.updateState()
  }

  toggle = () => {
    const isChecked = !this.isChecked()
    this.checkboxes.forEach(checkbox => checkbox.checked = isChecked)
    this.updateState(isChecked)
  }

  // Private
  isChecked = () => this.checkboxes.some(checkbox => checkbox.checked)

  updateState = (state) => {
    const isChecked = state !== undefined ? state : this.isChecked()

    if (this.hasLabelTarget)
      this.labelTarget.innerText = isChecked ? 'Tout déselectionner' : 'Tout sélectionner'

    if (this.hasSubmitTarget)
      this.submitTarget.toggleAttribute('disabled', !isChecked)
  }
}
